import {
  AUTH_TOKEN,
  AUTHENTICATED,
  SHOW_AUTH_MESSAGE,
  SHOW_AUTH_SUCCESS_MESSAGE,
  HIDE_AUTH_MESSAGE,
  HIDE_AUTH_SUCCESS_MESSAGE,
  SIGNOUT_SUCCESS,
  SIGNUP_SUCCESS,
  SHOW_LOADING,
  SIGNIN_WITH_GOOGLE_AUTHENTICATED
} from '../constants/Auth';

const initState = {
  loading: false,
  message: '',
  showMessage: false,
  redirect: '',
  token: localStorage.getItem(AUTH_TOKEN)
};

const auth = (state = initState, action) => {
  switch (action.type) {
    case AUTHENTICATED:
      return {
        ...state,
        loading: false,
        allowRedirect: true,
        redirect: '/app/dashboard/default',
        token: action.token
      };
    case SIGNIN_WITH_GOOGLE_AUTHENTICATED: {
      return {
        ...state,
        loading: false,
        allowRedirect: true,
        redirect: '/app/dashboard/default',
        token: action.token
      };
    }
    case SIGNUP_SUCCESS: {
      return {
        ...state,
        loading: false,
        token: action.token
      };
    }
    case SIGNOUT_SUCCESS: {
      return {
        ...state,
        token: null,
        redirect: '/',
        loading: false
      };
    }
    case SHOW_AUTH_MESSAGE:
      return {
        ...state,
        message: action.message,
        showMessage: true,
        loading: false
      };
    case HIDE_AUTH_MESSAGE:
      return {
        ...state,
        message: '',
        showMessage: false
      };
    case SHOW_AUTH_SUCCESS_MESSAGE:
      return {
        ...state,
        message: action.message,
        showSuccessMessage: true,
        showMessage: false,
        loading: false
      };
    case HIDE_AUTH_SUCCESS_MESSAGE:
      return {
        ...state,
        message: '',
        showSuccessMessage: false,
        showMessage: false
      };
    case SHOW_LOADING: {
      return {
        ...state,
        loading: true
      };
    }
    default:
      return state;
  }
};

export default auth;
